export default "__VITE_ASSET__CeaUDfsH__"